import { useCurrentWorkspace, Workspace } from '@gripp/shared-logic';
import { t } from 'i18next';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';
import { ExportButton } from './dataExport/exportButton';
import { useAccountsExport } from './dataExport/useAccountsExport';
import { useActivityExport } from './dataExport/useActivityExport';
import { useAssetExport } from './dataExport/useAssetExport';
import { useTagScanExport } from './dataExport/useTagScanExport';

const ExportCell = memo(({ workspace }: { workspace: Workspace }) => (
  <View style={styles.export}>
    <ExportButton
      useExport={useActivityExport}
      fileName="activity"
      workspace={workspace}
    />
    <ExportButton
      useExport={useAssetExport}
      fileName="assets"
      workspace={workspace}
    />
    <ExportButton
      useExport={useAccountsExport}
      fileName="accounts"
      workspace={workspace}
      label={t('People')}
    />
    <ExportButton
      useExport={useTagScanExport}
      fileName="tag-scan"
      workspace={workspace}
    />
  </View>
));

export const WorkspacesSection = () => {
  const { t } = useTranslation();
  const currentWorkspace = useCurrentWorkspace();
  
  if (!currentWorkspace) return null;

  return (
    <View>
      <View style={styles.infoHeaderContainer}>
        <Text style={styles.infoHeader}>{t('accountPage.workplaceTitle')}</Text>
      </View>
      <View
        style={[
          styles.workspacesContainer,
        ]}
      >
        <ExportButton
          useExport={useActivityExport}
          fileName="Activity"
          workspace={currentWorkspace}
        />
        <ExportButton
          useExport={useAssetExport}
          fileName="Assets"
          workspace={currentWorkspace}
        />
        <ExportButton
          useExport={useAccountsExport}
          fileName="Accounts"
          workspace={currentWorkspace}
          label={t('People')}
        />
        <ExportButton
          useExport={useTagScanExport}
          fileName="Tag-Scan"
          workspace={currentWorkspace}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  workspacesContainer: {
    flex: 1,
    gap: 4,
    overflow: 'hidden',
  },
  infoHeaderContainer: {
    flexDirection: 'column',
    alignSelf: 'flex-start',
    marginBottom: 16,
    width: '100%',
  },
  infoHeader: {
    fontSize: 16,
    fontWeight: '600',
  },
});
